if(!customElements.get('sold-counter')){
    class SoldCounter extends HTMLElement{
        constructor() {
            super();
            this.soldHistory = JSON.parse(this.dataset.soldHistory);
        }
        
        connectedCallback(){
            if(!this.soldHistory) return
            const soldCountElement = this.querySelector('.sold-count');
            
            if (!soldCountElement) {
                console.error('sold-count element not found');
                return;
            }
            const now = new Date();
            const todayUTC = now.getUTCFullYear() + '-' +
                            String(now.getUTCMonth() + 1).padStart(2, '0') + '-' +
                            String(now.getUTCDate()).padStart(2, '0');

            const soldToday = this.soldHistory[todayUTC] || 0;

            // Only show if sold today > 0
            if (soldToday > 0) {
                soldCountElement.textContent = soldToday + " Sold today";
                this.style.display = '';
            } else {
                this.style.display = 'none';
            }
        }
    }

    customElements.define('sold-counter', SoldCounter);
}